import { render, staticRenderFns } from "./DialogResume.vue?vue&type=template&id=546bbdff&"
import script from "./DialogResume.vue?vue&type=script&lang=js&"
export * from "./DialogResume.vue?vue&type=script&lang=js&"
import style0 from "./DialogResume.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports